import { OpsFeatures } from './../../ops-features';
import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { AuthService, User } from '../../shared/services/auth.service';
import { Store, select } from '@ngrx/store';
import { IState } from 'src/app/shared/store/root.reducer';
import { AppSettingsService, AppSettingEntities } from 'src/app/shared/services/app-settings.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FullScreenStateActions } from 'src/app/shared/store/full-screen.reducer';
import { CharKeyCode } from 'src/app/shared/domain/enums/characters-key-codes.enum';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.scss']
})
export class TopComponent implements OnInit, OnDestroy {

  navigationMenuCssClass: string;
  currentUser: User;
  fontSize = '';
  appSettingLoaded = false;
  currentMode = 'INIT';
  topBarCssClass: string;
  mainBarCssClass: string;
  pageWrapperCssClass: string;
  tooltipCssClass: string;
  subscriptions: Subscription[] = [];
  keyboardShortcuts = false;
  isManIdAvailable: boolean;
  isThirdPartyEnabled: boolean;
  supportLink = '';


  constructor(
    private authService: AuthService,
    private store: Store<IState>,
    private appSettingsService: AppSettingsService,
    private toastr: ToastrService,
    private router: Router,
    public opsFeatures: OpsFeatures) { }

  ngOnInit() {
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.currentUser)).subscribe(currentUser => {
      this.currentUser = currentUser;
    }));
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.appSettings.IsLoaded)).subscribe(isLoadedSettings => {
      this.appSettingLoaded = isLoadedSettings;
      if (this.appSettingLoaded) {
        this.fontSize = this.appSettingsService.getSetting('FontSize').value.toString();
        if (this.currentUser.userType === 1) {
          this.supportLink = environment.supportLinkShop;
        } else {
          this.supportLink = environment.supportLinkSupplier;
        }
      }
    }));

    this.subscriptions.push(this.store.pipe(select((state: IState) => state.fullScreen))
      .subscribe(fullScreenState => {
        this.topBarCssClass = fullScreenState.topBarCssClass;
        this.mainBarCssClass = fullScreenState.mainBarCssClass;
        this.pageWrapperCssClass = fullScreenState.pageWrapperCssClass;
        this.tooltipCssClass = fullScreenState.tooltipCssClass;
        this.navigationMenuCssClass = fullScreenState.navigationMenuCssClass;
    }));

    this.subscriptions.push(this.store.pipe(select(state => state.appParams.manufacturers))
      .subscribe(manufacturers => {
        this.isManIdAvailable = manufacturers.length > 0;
        this.isThirdPartyEnabled = manufacturers.filter(man => man.thirdPartyClaimEnabled === true).length > 0;
    }));

    this.currentMode = 'INIT';
  }

  logout() {
    if (this.currentUser.contactId !== 0) {
      this.authService.logout();
    }
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
  applyFontSize(event) {
    this.appSettingsService.writeSetting([{
      entityType: AppSettingEntities.CONTACT,
      key: 'FontSize',
      value: this.fontSize
    }]);
    this.toastr.info('Font Size was successfully updated', 'Font Updated');
  }

  fullScreenClick() {
    if (this.currentMode === 'INIT') {
      this.store.dispatch({
        type: FullScreenStateActions.SET_FULL_SCREEN_CONTENT
      });
      this.currentMode = 'FULL';
    } else {
      this.store.dispatch({
        type: FullScreenStateActions.INIT
      });
      this.currentMode = 'INIT';
    }
  }

  onKeyboardShortcuts() {
    this.keyboardShortcuts = !this.keyboardShortcuts;
  }

  foundFeatureCode(featureCode: string) {
    return this.currentUser.featuresCodes.indexOf(featureCode) > -1;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {

    if (event && event.key) {
      const keyPressed = event.key.toUpperCase();

      if (keyPressed === CharKeyCode.ESC) {
        if (this.currentMode === 'FULL') {
          this.fullScreenClick();
        } else if (this.keyboardShortcuts) {
          this.keyboardShortcuts = false;
        }
      }

      if (!event.altKey) {
        return;
      }

      switch (keyPressed) {
        case '?': {
          event.preventDefault();
          this.onKeyboardShortcuts();
          break;
        }
        case 'C': {
          if (!this.foundFeatureCode(this.opsFeatures.codes.DisableClaimQuote)) {
            event.preventDefault();
            this.router.navigate(['new-claim/step1']);
          }
          break;
        }
        case 'F': {
          if (this.currentMode === 'INIT') {
            event.preventDefault();
            this.fullScreenClick();
          }
          break;
        }
        case 'T': {
          if (!this.foundFeatureCode(this.opsFeatures.codes.DisableClaimQuote)) {
            event.preventDefault();
            this.router.navigate(['new-thirdparty-claim/step1']);
          }
          break;
        }
        case 'L': {
          event.preventDefault();
          this.router.navigate(['claim-status/claims']);
          break;
        }
        case 'P': {
          if (this.foundFeatureCode(this.opsFeatures.codes.PartSearch)) {
            event.preventDefault();
            this.router.navigate(['search-part']);
          }
          break;
        }
        case 'S': {
          if (this.foundFeatureCode(this.opsFeatures.codes.StatementHistory)) {
            event.preventDefault();
            this.router.navigate(['statement-history']);
          }
          break;
        }
        case 'U': {
          event.preventDefault();
          window.location.href = 'http://support.opstrax.com/';
          break;
        }
      }
    }
  }
}
